import React, { Component } from 'react';
import Formulario from './InformesForm';

class Informes extends Component{
    componentDidMount = () => {
        const { getModulo, listarPaises, listarDepartamentos } = this.props;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4])
        listarPaises();
        listarDepartamentos();
    }
    render(){
        const { loader, modulo, reporteListadoColaboradores, reporteBirthdays,
            listaP, excelReporteEmpleador, reporteRecibosPeriodo, listarColaborador,
            listarPlanillasRecibos, reportePromedioIngresos, listaPeriodo,
            reporteListadoFamilia, excelListadoFamilia, listarColaboradorTodos,
            reporteListadoPermisos, reporteSuspendidosIGSS, reportePrestamos,
            excelListadoColaboradores, deptos, reporteLiquidacionISR, excelLiquidacionISR,
            reporteISR, reporteLibroSalario, excelLibroSalario, reporteRecibosBono,
            listarColaboradorLiq, imprimirLiquidacion, reporteDescuentoJudicial, 
            reporteRecibosAguinaldo, reporteAntiguedadColaborador, listarColaboradorBajas  } = this.props;
        return(
            <div>
                <Formulario
                    loader = {loader}
                    modulo = {modulo}
                    reporteListadoColaboradores = {reporteListadoColaboradores}
                    reporteBirthdays = {reporteBirthdays}
                    obtenerPaises = {listaP}
                    excelReporteEmpleador = {excelReporteEmpleador}
                    listarColaborador = {listarColaborador}
                    listarColaboradorBajas = {listarColaboradorBajas}
                    reporteRecibosPeriodo = {reporteRecibosPeriodo}
                    listarPlanillasRecibos = {listarPlanillasRecibos}
                    reportePromedioIngresos = {reportePromedioIngresos}
                    listaPeriodo = {listaPeriodo}
                    reporteListadoFamilia = {reporteListadoFamilia}
                    excelListadoFamilia = {excelListadoFamilia}
                    listarColaboradorTodos = {listarColaboradorTodos}
                    reporteListadoPermisos = {reporteListadoPermisos}
                    reporteSuspendidosIGSS = {reporteSuspendidosIGSS}
                    reportePrestamos = {reportePrestamos}
                    excelListadoColaboradores = {excelListadoColaboradores}
                    deptos = {deptos}
                    reporteLiquidacionISR = {reporteLiquidacionISR}
                    excelLiquidacionISR = {excelLiquidacionISR}
                    reporteISR = {reporteISR}
                    reporteLibroSalario = {reporteLibroSalario}
                    excelLibroSalario = {excelLibroSalario}
                    reporteRecibosBono = {reporteRecibosBono}
                    listarColaboradorLiq = {listarColaboradorLiq}
                    imprimirLiquidacion = {imprimirLiquidacion }
                    reporteDescuentoJudicial = {reporteDescuentoJudicial}
                    reporteRecibosAguinaldo = {reporteRecibosAguinaldo}
                    reporteAntiguedadColaborador = {reporteAntiguedadColaborador}
                />
            </div>
        );
    }
}

export default Informes;
